<template>
	<div style="float:right;">
		<div style="text-align:right"> {{ messages.rate }}:
			<div style="margin:5px;" class="btn btn-light" @click.prevent="postpro">
				<span style="cursor:pointer">
					<img src="/images/pro.gif" width="16" height="30" :alt="messages.rate_positive" :title="messages.rate_positive" />
				</span>
				<div>({{ proCount }})</div>
			</div>
			<div style="margin:5px;" class="btn btn-light">
				<span style="cursor:pointer">
					<img src="/images/con.gif" width="16" height="30" :alt="messages.rate_negative" :title="messages.rate_negative" @click.prevent="postcon" />
				</span>
				<div>({{ conCount }})</div>
			</div>
		</div>

		<transition name="fade">
			<div v-if="thanks" class="thankyou" style="position:absolute;margin-top:-50px;margin-left:-200px;z-index:3;padding:10px;width:270px;border-radius: 5px;border:1px solid #ccc;opacity: 0.94;text-align:center">
				<h3>{{ messages.rate_thankyou }}</h3>
			</div>
		</transition>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';

const props = defineProps(['model', 'id', 'pro', 'con']);
const proCount = ref(props.pro);
const conCount = ref(props.con);
const thanks = ref(false);
const messages = window.messages;

const postpro = () => {
	thanks.value = true;
	setTimeout(() => {
		thanks.value = false;
	}, 4000);
	axios.post(`/ThumbsUpRating/${props.model}/${props.id}`, {
		pos: "+1"
	}).then((res) => {
		proCount.value = res.data.pro;
		conCount.value = res.data.con;
	}).catch(error => {
		// Handle error
	});
};

const postcon = () => {
	thanks.value = true;
	setTimeout(() => {
		thanks.value = false;
	}, 4000);
	axios.post(`/ThumbsUpRating/${props.model}/${props.id}`, {
		pos: "-1"
	}).then((res) => {
		proCount.value = res.data.pro;
		conCount.value = res.data.con;
	}).catch(error => {
		// Handle error
	});
};

const percentage = computed(() => {
	if (proCount.value > 0 || conCount.value > 0) {
		return Math.round((proCount.value * 100) / (conCount.value + proCount.value));
	}
	return 0;
});
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>
